import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import ModalRingList from "./ModalRingList";
import ModalCategoryList from "./ModalCategoryList";
import ModalFortuneList from "./ModalFortuneList";
import ModalColorList from "./ModalColorList";

export default class ModalMaterial extends Component {
  handleCloseModal() {
    let { handleCloseDialog, handleUpdateState, designInfo } = this.props;

    // if (designInfo.ringId === 0) {
    //   handleUpdateState("isShowDialogMessage", true);
    //   handleUpdateState("dialogMessage", "続行する前にリングを選択する必要があります");

    //   return;
    // }

    handleCloseDialog("isShowModalMaterial");
  }

  handleChangeTab(tabIndex) {
    let { handleUpdateState } = this.props;

    handleUpdateState("idMaterialActive", tabIndex);
  }

  render() {
    let { isShowModalMaterial, idMaterialActive, ringIdActive } = this.props;
    let renderTabContent = <ModalRingList {...this.props} />;
    let ringName = "リング";

    // Check ring type
    switch (ringIdActive) {
      case 2:
        ringName = "紐";
        break;
      case 7:
        ringName = "金具";
        break;
      default:
        ringName = "リング";
        break;
    }

    // render tab content
    switch (idMaterialActive) {
      case 1:
        renderTabContent = <ModalRingList {...this.props} />;
        break;
      case 2:
        renderTabContent = <ModalCategoryList {...this.props} />;
        break;
      case 3:
        renderTabContent = <ModalFortuneList {...this.props} />;
        break;
      case 4:
        renderTabContent = <ModalColorList {...this.props} />;
        break;
      default:
        break;
    }

    return (
      <Modal
        show={isShowModalMaterial}
        aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="modal_fullW modal_custom modal_custom_fullW"
        onHide={() => this.handleCloseModal()}
        centered
      >
        <Modal.Body>
          <button
            className="modal_close"
            onClick={() => this.handleCloseModal()}
          >
            <img src="/img/icon_close_new.png" alt="" />
          </button>
          <ul className="modal_tabs">
            <li>
              <button
                className={`${idMaterialActive === 1 ? "active" : ""}`}
                onClick={() => this.handleChangeTab(1)}
              >
                <div className="list_btn_popup">
                  <img className="popup_ring_new" src="/img/ring_new.png" alt="" />
                  <span> {ringName}</span>
                </div>

              </button>
            </li>
            <li>

              <button
                className={`${idMaterialActive === 2 ? "active" : ""}`}
                onClick={() => this.handleChangeTab(2)}
              >
                <div className="list_btn_popup">
                  <img className="popup_storn_new" src="/img/storn_new.png" alt="" />
                  <span> 素材</span>
                </div>
              </button>
            </li>
            <li>
              <button
                className={`${idMaterialActive === 3 ? "active" : ""}`}
                onClick={() => this.handleChangeTab(3)}
              >
                <div className="list_btn_popup">
                  <img className="popup_weather_star_new" src="/img/weather_star_new.png" alt="" />
                  <span> 運気</span>
                </div>
              </button>
            </li>
            <li>
              <button
                className={`${idMaterialActive === 4 ? "active" : ""}`}
                onClick={() => this.handleChangeTab(4)}
              >
                <div className="list_btn_popup">
                  <img className="popup_hart_new" src="/img/hart_new.png" alt="" />
                  <span> カラー</span>
                </div>
              </button>
            </li>
          </ul>

          {/* Content */}
          {renderTabContent}
        </Modal.Body>
      </Modal>
    );
  }
}
